
import * as utc from "../../util/utc.js";
import {resolveTimeCursor} from "../../util/dates.js";
import {createOstiaSST, createOstiaSSTA} from "../ostia/ostia.js";
import {createRTGSST, createRTGSSTA} from "../rtg/rtg.js";


const OSTIA_SWITCH_DATE = utc.date({year: 2019, month: 12, day: 15});
const SST_TIMELINE = [
    {
        type: "recurring_interval",
        start: "2013-11-01T00:00Z",
        frequency: {hours: 24},
    },
];

function isOstia(time_cursor) {
    return utc.date(resolveTimeCursor(time_cursor)) >= OSTIA_SWITCH_DATE;
}

export function createSSTLayer(attr) {
    return isOstia(attr.time_cursor) ? createOstiaSST(attr, SST_TIMELINE) : createRTGSST(attr, SST_TIMELINE);
}

export function createSSTALayer(attr) {
    return isOstia(attr.time_cursor) ? createOstiaSSTA(attr, SST_TIMELINE) : createRTGSSTA(attr, SST_TIMELINE);
}
